export default {
  permissionDenied:
    'We need permission to record your video and audio. Click the security status icon in your Chrome browser’s address bar and allow access to proceed.',
  smart_capture: {
    title: 'Record your interactions',
    description:
      'You can later add voiceovers, edit and publish to <b>%{workspace_name}</b>',
    placeholder: 'Start by presenting your screen.',
    placeholder_install_ext:
      'Start creating your new video by installing the extension.',
    install_extension: 'Install Chrome Extension to Proceed',
    share_and_record: 'Share screen and record',
    note: {
      tag: 'ALL-NEW',
      title:
        'Just present your screen. Trainn’s smart capture will do the rest.',
      description:
        'Useful for creating product walkthrough videos, or product demos.'
    }
  },
  screen: {
    title: 'Record your screen',
    description: 'Cast your screen and record instantly.',
    placeholder: 'Present your screen to start recording.',
    share_and_record: 'Share screen and record',
    header_title: 'Select your voice and automation preferences',
  },
  webcam: {
    title: 'Record yourself',
    description: 'Camera is on. Don’t forget to smile. :)',
    placeholder: 'Switch on your camera',
    start_recording: 'Start Recording'
  },
  stream_file: {
    title: 'Record over a PDF',
    description: 'Present your PDF and start recording.',
    placeholder:
      'Upload your presentation and record a video while navigating through the slides.',
    upload_pdf: 'Upload PDF',
    start_recording: 'Start Recording'
  },
  file: {
    title: 'Upload and edit',
    description: 'Upload & edit files on your device.',
    placeholder: 'Drag and drop files here',
    open_my_files: 'Or open my files…',
    upload_file: 'Upload Files...',
    note: 'Formats supported: .mp4, .mov, .jpeg, .png, .pdf',
    upload_and_edit: 'Upload and edit',
    proceed: 'Proceed',
    trimAndProceed: 'Trim and proceed',
    recent_files: {
      title: 'Choose file…',
      description:
        'You can import images, PDFs, or snippets from videos from your recent files or local storage.',
      empty: 'No recent files',
      video: 'Video',
      image: 'Image'
    }
  },
  clips_selector: {
    title: 'Create Clips and Use in Your Video',
    description:
      'Choose to add snippets by specifying start and end time from the chosen video.',
    optional: '(optional)',
    make_clips: 'Create Clips and Use in Your Video',
    start_time: 'Start time',
    end_time: 'End time',
    add_snippet: 'Add snippet',
    upload_and_edit: 'Upload and Edit'
  },
  start: 'Start Recording',
  pause: 'Pause',
  resume: 'Resume',
  cancel: 'Cancel',
  stop: 'Finish Recording',
  last_updated: 'Last updated:',
  submit_video: 'Submit Video',
  publish_preview_video: 'Preview and Publish',
  audio_generating: 'Generating audio... \n Please wait :)',
  publish_video: 'Publish Video',
  exit_preview: 'Exit preview',
  uploading_in_progress:
    'Hang tight! We are uploading your recording. This might take a few seconds.',
  camera_off: "Someone's too shy. <br /> Alright, someother time :)",
  max_upload_size: 'Maximum Upload Size: %{size}MB',
  onboarding: {
    title: "Before we begin...",
    tip: "Tip",
    of: "of",
    tip_1:
      "We will split the screen recording into multiple clips based on the interactions you do on the screen.<br/> <br/>We will automatically add zooms and highlights wherever required.",
    tip_2:
      "You can add human-like voiceovers after recording your screen. <br/><br/>Just type your voiceover for each clip while editing, trainn will automatically convert it into speech.",
    tip_3:
      'If you want to highlight an area on the screen without clicking it, use "Control (or) Command + Hover" on the area. <br/><br/>This will be treated as a block which you can edit later.',
    next_tip: "Next Tip",
    finish: "Finish & Start Recording",
  },
  recording_blocked: "You've reached your content creation limit. Please upgrade or contact support.",
  mode_selector: {
    title: 'How would you like to start?',
    subtitle: 'Record a fresh walkthrough or bring in a video you already have.',
    popular: 'Most popular',
    agent: {
      title: 'Create with Agent',
      beta: 'BETA',
      description:
        'Meet Lara, the editing agent that turns any raw recording into a polished video, on its own.',
      start: 'Start',
      limit_reached:
        'Agent creation is not available on your current plan. Upgrade or contact support to create with Laura.'
    },
    options: {
      screen: {
        title: 'Record my screen',
        description:
          'Capture a walkthrough of your product directly from your browser.'
      },
      screen_and_cam: {
        title: 'Screen and webcam',
        description: 'Record your screen with your webcam overlaid on top.'
      },
      webcam: {
        title: 'Cam only',
        description: 'Record yourself using just your webcam.'
      },
      stream_file: {
        title: 'Present over PDF',
        description: 'Narrate your slides while presenting a PDF.'
      },
      upload: {
        title: 'Upload a video & edit',
        description: 'Drop in a video file from your computer to start editing.'
      }
    }
  },
  agent_setup: {
    header_title: 'Set up your recording with Lara',
    switch_to_default: 'Switch to default',
    start_here: 'Start here',
    intro_title: "Hi, I'm Lara",
    intro_desc:
      "You can record your screen or upload a video, and I'll take it from there. My job is to understand your video, add contextual narrations, edit clips, and hand you back a polished video, ready to share.",
    record: {
      title: 'Record my screen',
      subtitle: 'You record, Lara edits'
    },
    upload: {
      title: 'Upload a video',
      subtitle: 'You upload, Lara edits'
    },
    upload_heading: 'Upload your video',
    drop_title: 'Drag and drop your video here',
    browse_hint: 'MP4 or MOV · up to 5 minutes',
    choose_file: 'Choose File',
    upload_button: 'Upload',
    uploading: 'Uploading your video…',
    invalid_type: 'Unsupported file. Please upload an MP4 or MOV video.'
  },
  agentic_mode: {
    title: 'Agentic Mode',
    beta: 'BETA',
    description_off:
      'Classic recording — Trainn auto-adds spotlights, zooms and narration as you go.',
    description_on:
      'Hand it off to the agent — it edits, narrates and polishes the final cut for you.',
    off: 'Off',
    on: 'On',
    editing_in_progress_title: 'Sit back while Lara edits for you.',
    editing_in_progress_subtitle:
      'A few minutes now will save you hours of editing.',
    editing_less_than_minute: 'Started less than a minute ago',
    editing_runtime: 'About %{minutes} min elapsed',
    limit_reached:
      "You've reached your Agentic Mode video limit. Please upgrade or contact support."
  }
};
